import { useAuth0 } from "@auth0/auth0-react"
import { useMutation } from "react-query"
import { Project } from "src/models/shared/projects";
import { ProjectsService } from "src/services/projects.service";

interface UpdateProjectRequest {
    projectId: string; 
    updates: Partial<Project>;
}

export const useUpdateProject = () => {
    const auth0 = useAuth0();
    return useMutation({
        mutationFn: async (request: UpdateProjectRequest) => {
            console.log(`useUpdateProject invoked for: ${request.projectId}`, request.updates);
            const account = await ProjectsService.updateProject(request.projectId, request.updates, auth0);
            return account;
        }
    })
};